import { FC, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { ko } from 'date-fns/locale';

type DateType = Date | null | undefined;

interface DatePickerProps {
    date: DateType;
    selectsStart?: boolean;
    selectsEnd?: boolean;
    minDate?: Date;
    minTime?: Date;
    maxDate?: Date;
    maxTime?: Date;
    disabled?: boolean;
    placeholderText?: string;
    changed_date?: (date: Date) => void;
    filter_time?: (date: Date) => boolean;

    showTimeSelect?: boolean;
    timeIntervals?: number;

    showTimeInput?: boolean;
    format?: string;
    className?: string;
    title?: string;
}
export const DatePicker: FC<DatePickerProps> = (props) => {
    const {
        date,
        minDate,
        minTime,
        maxDate,
        maxTime,
        selectsStart,
        selectsEnd,
        disabled,
        showTimeSelect,
        timeIntervals,
        showTimeInput,
        format,
        className,
        title,
        placeholderText,
        changed_date,
        filter_time,
    } = props;
    const dateFormat = format ? format : showTimeSelect ? 'yyyy.MM.dd HH:mm' : 'yyyy.MM.dd';
    const [isOpen, setIsOpen] = useState(false);
    return (
        <ReactDatePicker
            placeholderText={placeholderText}
            locale={ko}
            selected={date}
            disabled={disabled}
            onChange={(date: DateType) => {
                if (changed_date) changed_date(date!);
            }}
            onInputClick={() => setIsOpen(true)}
            onClickOutside={() => setIsOpen(false)}
            filterTime={filter_time}
            open={isOpen}
            dateFormat={dateFormat}
            selectsStart={selectsStart}
            selectsEnd={selectsEnd}
            minDate={minDate}
            minTime={minTime}
            maxDate={maxDate}
            maxTime={maxTime}
            showTimeSelect={showTimeSelect}
            timeIntervals={timeIntervals}
            showTimeInput={showTimeInput}
            wrapperClassName={className}
            title={title}
        />
    );
};
